<template>
    <div class="main-container">
        <div class="head-container">
            <div class="form-label">
                <span>名  称：</span>
            </div>
            <div class="form-input">
                <Input v-model="formParam.name"/>
            </div>
            <div class="form-button">
                <Button type="primary" icon="md-search" style="margin-right: 10px" @click="onQuery">查询</Button>
            </div>
        </div>
        <div class="button-container">
            <Button type="primary" icon="md-add" style="margin-right: 20px" @click="showModal">添加目录</Button>
        </div>
        <div class="table-container">
            <Table :columns="columns" :data="tableData">
                <template #action="{ row, index }">
                    <Button class="table-button-edit" size="small" style="margin-right: 5px" @click="edit(row)">编辑</Button>
                    <Poptip
                        confirm
                        title="该目录下所有的材料都会删除，确定删除?"
                        @on-ok="remove(row)" placement="top-start" transfer>
                        <Button class="table-button-remove" size="small">删除</Button>
                    </Poptip>
                </template>
            </Table>
            <div style="margin-top: 10px;text-align: right">
                <Page v-model="formParam.current" :page-size="formParam.size"
                      :total="formParam.total"
                      @on-change="onPageChange"
                      @on-page-size-change="onPageSizeChange"
                      show-sizer show-elevator show-total/>
            </div>
        </div>
        <Modal
            v-model="modal"
            title="新增目录"
            footer-hide>
            <div>
                <Form :model="formItem" :label-width="80" ref="formItem" :rules="rules">
                    <FormItem label="目录名称" prop="name">
                        <Input v-model="formItem.name" placeholder="请输入目录名称"></Input>
                    </FormItem>
                    <FormItem label="备注" prop="remark">
                        <Input v-model="formItem.remark" placeholder="请输入备注"></Input>
                    </FormItem>
                </Form>
                <div slot="footer" style="text-align: right">
                    <Button style="margin-right: 10px" type="primary" :loading="loading" @click="handleOk">确定</Button>
                    <Button @click="handleCancel">取消</Button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import {saveMaterialsCatalog, removeMaterialsCatalog, queryMaterialsCatalogPage} from "@/api/baseData"

export default {
    name: "MaterialsCatalog",
    data() {
        return {
            formParam: {
                name: '',
                total: 0,
                current: 1,
                size: 10,
            },
            formItem: {
                name: '',
                remark: '',
            },
            modal: false,
            loading: false,
            rules: {
                name: [
                    {required: true, message: '目录名称不能为空', trigger: 'blur'},
                ],
            },
            columns: [
                {
                    title: '目录名称',
                    key: 'name',
                    align: 'left',
                    width: 120,
                },
                {
                    title: '备注',
                    key: 'remark',
                    align: 'center',
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    align: 'center',
                    width: 180,
                },
                {
                    title: '操作',
                    slot: 'action',
                    width: 160,
                    align: 'center',
                },
            ],
            tableData: [],
        }
    },
    mounted() {
        this.onQuery()
    },
    methods: {
        async onQuery() {
            let res = await queryMaterialsCatalogPage(this.formParam)
            if (res.data != null) {
                this.tableData = res.data
                this.formParam.current = res.current
                this.formParam.total = res.total
            }
        },
        showModal() {
            this.formItem = {
                name: '',
                remark: '',
            }
            this.modal = true
        },
        handleOk() {
            this.loading = true
            this.$refs.formItem.validate(async (valid) => {
                if (valid) {
                    await saveMaterialsCatalog(this.formItem)
                    this.loading = false
                    this.modal = false
                    this.onQuery()
                } else {
                    this.loading = false
                }
            })
        },
        handleCancel() {
            this.modal = false
        },
        edit(row) {
            this.formItem = Object.assign({}, row)
            this.modal = true
        },
        async remove(row) {
            await removeMaterialsCatalog(row)
            await this.onQuery()
        },
        onPageChange(e) {
            this.formParam.current = e
            this.onQuery()
        },
        onPageSizeChange(e) {
            this.formParam.current = 1
            this.formParam.size = e
            this.onQuery()
        },
    },
}
</script>

<style scoped>
.form-label {
    display: inline-block;
    font-weight: bold;
    margin-left: 10px;
}

.form-input {
    display: inline-block;
    width: 400px;
    margin-right: 15px;
}

.head-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.button-container {
    margin: 10px;
    background: #fafafa;
    padding: 10px;
}

.form-button {
    display: inline-block;
}

.table-container {
    margin: 10px;
}
</style>
